<template>
  <q-dialog ref="dialog" persistent @hide="onDialogHide">
    <q-card class="q-dialog-plugin" style="width: 650px; max-width: 650px;">
      <slot name="title">
        <q-card-section>
          <h6 class="q-card-title">
            {{ title }}
          </h6>
        </q-card-section>
      </slot>

      <slot name="messages">
        <q-card-section v-if="messages.length">
          <q-list>
            <q-item v-for="message in messages" :key="message">
              {{ message }}
            </q-item>
          </q-list>
        </q-card-section>
      </slot>

      <slot name="actions">
        <q-card-actions align="right">
          <EnhancedQSelect
            v-if="replaceOptions.length"
            v-model="replacement"
            :options="replaceOptions"
            label="Replacement"
          />

          <q-btn color="negative" :label="confirmLabel" @click="onOKClick" />
          <q-btn flat label="Cancel" @click="onCancelClick" />
        </q-card-actions>
      </slot>
    </q-card>
  </q-dialog>
</template>

<script>
import EnhancedQSelect from '@components/general/EnhancedQSelect'

export default {
  components: {
    EnhancedQSelect
  },

  props: {
    title: String,

    messages: {
      type: Array,
      default: () => []
    },

    replaceOptions: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    replacement: null
  }),

  computed: {
    confirmLabel() {
      if (this.replacement) return 'Replace and delete'
      if (!this.replacement && this.replaceOptions.length) return 'Delete anyway'
      return 'Confirm'
    }
  },

  methods: {
    show() {
      this.$refs.dialog.show()
    },

    hide() {
      this.$refs.dialog.hide()
    },

    onDialogHide() {
      this.$emit('hide')
    },

    onOKClick() {
      this.$emit('ok', { replace: this.replacement })
      this.hide()
    },

    onCancelClick() {
      this.hide()
    }
  }
}
</script>
